import styled from 'styled-components';
import theme from 'styles/theme';

export const ServiceContentsList = styled.ul`
  li {
    display: flex;
    position: relative;
    width: 100%;
    padding: 16px 0 17px;
    margin-left: 0;
    border-top: 1px solid ${theme.borderColor.lightGrey};
    cursor: pointer;
  }

  .questionMark {
    margin: 7px 5px 4px;
    line-height: 2.7rem;
    font-size: 1.5rem;
    font-weight: 400;
    color: #009ff9;
  }

  .textBox {
    width: calc(100% - 36px);

    .titleRow {
      display: -webkit-box;
      margin: 4px 0 4px;
      font-size: 1.5rem;
      font-weight: 400;
      line-height: 2.7rem;
      color: ${theme.color.black};
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    .descriptionRow {
      font-size: 1.3rem;
      font-weight: 400;
      line-height: 2rem;
      color: ${theme.color.grey7};
    }
  }

  .iconWrap {
    margin: auto;
  }
`;
